import React, { Component } from 'react';
import Map from './Componets/Map';
import SharedRydeMap from './Componets/SharedRydeMap';
// import { Map, Marker } from 'react-leaflet';
// import TripTable from './Componets/TripTable';
import LeftSideNav from './Componets/LeftSideNav';
import RightTopSideNav from './Componets/RightTopSideNav';
import RightBottomSideNav from './Componets/RightBottomSideNav'
import BottomSlideView from './Componets/BottomSlideView'
import BottomSideNav from './Componets/BottomSideNav'
import SchedulingOrderStatus from './Componets/SchedulingOrderStatus'
import ScheduleAllDialog from './Componets/ScheduleAllDialog'
import LoginModal from './Componets/LoginModal';
import './App.css';
import openSocket from 'socket.io-client';
import socketIOClient from 'socket.io-client'
// import DatePicker from 'react-date-picker';
// import DatePicker from 'react-date-picker/dist/entry.nostyle'
// import 'react-date-picker/dist/DatePicker.css';
import { DatePicker, DatePickerInput } from 'rc-datepicker';
import 'rc-datepicker/lib/style.css';
// import MarkerClusterGroup from 'react-leaflet-markercluster';
import { Button as AntdBtn, Icon as AntIcn } from 'antd';
// import {View, Button as ReactNativeBtn, Text} from 'react-native';
// import SlidingUpPanel from 'rn-sliding-up-panel';
import ReactTimeout from 'react-timeout';
import Image from 'react-bootstrap/lib/Image';
import { Popover, Row, Col, Input, Modal, Layout, Select, Spin } from 'antd';
const confirmModal = Modal.confirm;
const parser = new DOMParser();
const { Header, Content } = Layout;
const Option = Select.Option;
const colSep = String.fromCharCode(14);
const rowSep = String.fromCharCode(15);
var aTestSocket = null;
let thisContext = null;

Date.prototype.addDays = function (days) {
  var date = new Date(this.valueOf());
  date.setDate(date.getDate() + days);
  return date;
}

class App extends Component {
  constructor() {
    super();
    this.state = {
      selectedDate: this.formatDate(new Date()),
      // selectedDate: "21-MAY-2018",
      trips: [],
      schedulingOrder: [],
      schedules: [],
      schedulesBrief: [],
      operidOptions: [<Option key="ALL">ALL OPERATORS</Option>],
      selectedOperid: "ALL",
      activeTripsSegmentsTabKey: "0",
      activeTab: 0,
      // segmentsTabDisabled: true,
      tripsPolylineFinishLoading: true,
      selectedTripsClustersRb: "trips",
      selectedPuDoRb: "pudo",
      selectedTimeSlots: { 0: true, 1: true, 2: true, 3: true, 4: true, 5: true, 6: true, 7: true, 8: true, 9: true, 10: true, 11: true, 12: true, 13: true, 14: true, 15: true, 16: true, 17: true, 18: true, 19: true, 20: true, 21: true, 22: true, 23: true, 24: true, 25: true, 26: true, 27: true, 28: true, 29: true, 30: true, 31: true, 32: true, 33: true, 34: true, 35: true, 36: true, 37: true, 38: true, 39: true, 40: true, 41: true, 42: true, 43: true, 44: true, 45: true, 46: true, 47: true, 48: true, 49: true, 50: true, 51: true, 52: true, 53: true, 54: true, 55: true, 56: true, 57: true, 58: true, 59: true, 60: true, 61: true, 62: true, 63: true, 64: true, 65: true, 66: true, 67: true, 68: true, 69: true, 70: true, 71: true, 72: true, 73: true, 74: true, 75: true, 76: true, 77: true, 78: true, 79: true, 80: true, 81: true, 82: true, 83: true, 84: true, 85: true, 86: true, 87: true, 88: true, 89: true, 90: true, 91: true, 92: true, 93: true, 94: true, 95: true },
      selectAllTimeSlots: 1,
      timeSlotMin: 0,
      timeSlotMax: 95,
      // visible: false,
      // monitorSchedulingSorder: "all",
      // monitorSchedulingOrderTimeOut: null,
      // nodeJSVersion: {},
      showSpinModal: false,
      spinModalWidth: 0,
      spinModalHeight: 0,
      spinTip: "",
      disableSelectOperid: false,
      dbVersion: "",
      gseVersion: "",
      uiVersion: "r" + window.SitConfig.AppVersion,
      monitorSchedulingOrderInterval: window.SitConfig.MonitorSchedulingOrderInterval,
      reloadSchedulingOrdersCount: 0,
      reloadTripsCount: 0,
      reloadSchedulesCount: 0,
      activeSchedulingOrderCardIdx: 0,
      loginVisible: false,
      userName: "",
      password: "",
      sessionObj: {},
      siteType: "",
      // QRydeMappBaseUrl: "http://50.233.95.50:4000/QRyde_Mapp/",
      // GSENodeJsUrl: "http://50.233.95.54:10069",
      schedulingOrderStatusData: {},
      // monitorSchedulingOrderStatusTimeOut: null,
      monitorSchedulingOrderStatusInterval: window.SitConfig.MonitorSchedulingOrderStatusInterval,
      datePickerDisabled: false,
      gseStatus: {}
    }
    this.loginUserName = '';
    // this.QRydeMappBaseUrl = "http://localhost:13004/";
    // this.QRydeMappBaseUrl = "http://50.233.95.50:4000/QRyde_Mapp/";
    this.QRydeMappBaseUrl = window.SitConfig.QRydeMappBaseUrl;
    this.OsrmBaseUrl = window.SitConfig.OsrmBaseUrl;
    // this.GSENodeJsUrl = "http://50.233.95.54:10069"; //38.4
    // this.GSENodeJsUrl = "http://50.233.95.54:10116"; //38.207
    /* this.GSENodeJsUrl = window.SitConfig.GSENodeJsUrl; 
    this.socket = openSocket(this.GSENodeJsUrl);
    this.socket.on('finish',
      (data) => this.do(data)
    );
    this.socket.on('connect_error',
      (data) => console.log(data.message)
    ); */
    // this.GSENodeJsUrl = "http://192.168.38.4:8000";
    this.selectedOperid = "ALL";
    this.selectedOperidIdx = 0;
    // this.disableSelectOperid = false;
    this.monitorSchedulingOrderStatusTimeOut = null;
    this.monitorSchedulingSorder = "all";
    this.monitorSchedulingOrderTimeOut = null;
    this.onDateChange = this.onDateChange.bind(this);
    this.onSelectOperidChange = this.onSelectOperidChange.bind(this);
    this.checkSchedulingOrderStatus = this.checkSchedulingOrderStatus.bind(this);
    this.onReceiveFindBestResult = this.onReceiveFindBestResult.bind(this);
    this.getSchedulesBrief = this.getSchedulesBrief.bind(this);
    this.reloadSegmentsOnFinishFindBest = this.reloadSegmentsOnFinishFindBest.bind(this);
    this.getSchedulesBriefOnFinishFindBest = this.getSchedulesBriefOnFinishFindBest.bind(this);
    this.processLogout = this.processLogout.bind(this);
    this.map = React.createRef();
    this.rightbottomsidenav = React.createRef();
    this.clearFindBest = this.clearFindBest.bind(this);
    this.handleRefreshTrips = this.handleRefreshTrips.bind(this);
    this.showSpinModal = this.showSpinModal.bind(this);
    this.righttopsidenav = React.createRef();
    this.leftsidenav = React.createRef();
    this.scheduleAllDialog = React.createRef();
    this.loginModal = React.createRef();
    /* let aSiteElements = window.location.href.toUpperCase().split("?U=");
    if (aSiteElements != null && aSiteElements.length > 1) {
      this.state.userName = aSiteElements[1].toUpperCase();
    } */
    let aUrl = window.location.href;
    // aUrl = "https://penquis-gse.hbssweb.com/GSE/";
    // aUrl = "http://penquisdev-gse.qryde.info/GSE/";
    // aUrl = "http://penquis-gse.qryde.info/GSE/";
    // aUrl = "http://kvcap-gse.qryde.info/GSE/";
    // aUrl = "http://kvcapdev-gse.qryde.info/GSE/";
    // aUrl = "http://atlantic-gse.qryde.info/GSE/";
    // aUrl = "http://frndrides-gse.qryde.info/GSE/";
    // aUrl = "http://mart-gse.qryde.info/GSE/";
    // aUrl = "http://crc-gse.qryde.info/GSE/";
    // aUrl = "https://penquis-gse.qryde.net/GSE/";
    let aSiteElements = aUrl.split("-");
    if (aSiteElements != null && aSiteElements.length > 1) {
      let bSiteElements = aSiteElements[0].split("//");
      if (bSiteElements != null && bSiteElements.length > 1) {
        this.state.userName = bSiteElements[1].toUpperCase();
        let cSiteElements = aSiteElements[1].split("/");
        if (cSiteElements != null && cSiteElements.length != 0) {
          let dSiteElements = cSiteElements[0].split(".");
          this.state.siteType = dSiteElements[dSiteElements.length - 1];
        }
      }
    } else {
      this.state.userName = window.SitConfig.LocalhostTestSite;
    }
    // this.initTestSocket();
    this.GSENodeJsUrl = "";
    this.GseSplitBatch = false;
    for (var i = 0; i < window.SitConfig.GSENodeJsSites.length; i++) {
      if (window.SitConfig.GSENodeJsSites[i].SiteName === this.state.userName) {
        this.GSENodeJsUrl = window.SitConfig.GSENodeJsSites[i].Url;
        if (window.SitConfig.GSENodeJsSites[i].SplitBatch != null && typeof window.SitConfig.GSENodeJsSites[i].SplitBatch == "boolean" && window.SitConfig.GSENodeJsSites[i].SplitBatch) {
          this.GseSplitBatch = true;
        }
        break;
      }
    }
    this.socket = openSocket(this.GSENodeJsUrl);
    this.socket.on('finish',
      // (data) => this.do(data)
      (data) => this.handleReceiveNodeJs(data)
      // (data) => this.handleReceiveSchedulingOrderStatus(data)
    );
    this.socket.on('connect_error', function (data) {
      console.log(data.message)
      // this.checkSchedulingOrderStatus();
      // this.socket.emit("-version", 'N');
    }
      // (data) => console.log(data.message)
    );
    this.socket.emit("-version", 'N');

    /* let aTestUrl = "wss://wslive.qryde.com:9308";
    // let aTestUrl = "wss://reststg.qryde.com:9308";
    let aTestSocket = new WebSocket('wss://wslive.qryde.com:9308');
    aTestSocket.addEventListener('open', function (event) {
      aTestSocket.send('0~test_echo');
    });
    aTestSocket.addEventListener('message', function (event) {
      console.log('Message from server ', event.data);
    }); */
    // this.setSessionUser({});
    this.getDbVersion();
  }

  /* initTestSocket(){
    aTestSocket = openSocket("http://localhost:4001");
    aTestSocket.on('ShowSchedules', (data) => {
      console.log(data);
    })
    aTestSocket.on('GetSchedulingOrder', (data) => {
      console.log(data);
    })
    aTestSocket.on('GetTrips', (data) => {
      console.log(data);
    })
  } */

  componentWillMount() {
    var aSessionObj = this.getSessionUser();
    if (aSessionObj != null && !this.isEmptyObj(aSessionObj) && aSessionObj.user != null && typeof aSessionObj.user == "string" && aSessionObj.user.length != 0) {
      this.setState({ sessionObj: aSessionObj });
      this.getOperIds();
      this.getSchedulingOrders(false);
      this.getTrips();
      this.getSchedules(-1);
      this.setState({
        loginVisible: false,
      });
      this.checkSchedulingOrderStatus();
    } else {

    }
  }

  showLoginModal = () => {
    this.setState({
      loginVisible: true,
    });
  }

  handleLoginClick = (e) => {
    console.log(e);
    if (this.state.userName != null && this.state.userName.length != 0) {
      this.getSchedulingOrders(false);
      this.getTrips();
      this.getSchedules(-1);
      this.setState({
        loginVisible: false,
      });
    }
  }

  initTrips() {
    let aTrips = require('./DataSource/testTrips.json').TRIPS;
    this.state.trips = [];
    for (var i = 0; i < aTrips.length; i++) {
      if (aTrips[i].stoptype === 'P') {
        for (var j = 0; j < aTrips.length; j++) {
          if (aTrips[j].stoptype === 'D' && aTrips[j].tripid === aTrips[i].tripid) {
            this.state.trips.push({
              pu: aTrips[i],
              do: aTrips[j]
            });
          }
        }
      }
    }
  }

  /* componentWillMount() {
    this.getSchedulingOrders(false);
    this.getTrips();
    this.getSchedules();
  } */

  componentDidMount() {
    // this.showLoginModal();
    /* this.setState({
      activeTripsSegmentsTabKey: "0",
      activeTab: 0,
      segmentsTabDisabled: true
    }) */
    document.getElementById("myBottomNav").hidden = true;
    document.getElementById("myLeftSidenav").hidden = true;
  }

  getSessionUser() {
    var aSessionStr = sessionStorage.getItem("qryde_tracking_session");
    return JSON.parse(aSessionStr);
    var aRes = {
      // user_name: "test_user"
    };
    /* if (aSessionStr !== null && typeof aSessionStr === "string" && aSessionStr.length !== 0) {
      var aSessionObj = JSON.parse(aSessionStr);
      if (aSessionObj != null && typeof aSessionObj !== "undefined" && !this.isEmptyObj(aSessionObj) &&
        aSessionObj.tenant_id != null && typeof aSessionObj.tenant_id === "number" && aSessionObj.tenant_id > 0 &&
        aSessionObj.user_id != null && typeof aSessionObj.user_id === "string" && aSessionObj.user_id.length != 0) {
        aRes = aSessionObj;
      }
    } */
    return aRes;
  }

  setSessionUser(theUser) {
    sessionStorage.setItem("qryde_tracking_session", JSON.stringify(theUser));
  }

  getDbVersion() {
    let aUrl = this.QRydeMappBaseUrl + '613GetOsrmVersion?data=' + this.state.userName;
    let aDate = "";
    fetch(aUrl + aDate)
      .then(res => res.json())
      .then(
        (result) => {
          if (result != null && result.cmd_name != null && result.cmd_name === '613GetOsrmVersion' && result.status != null
            && result.status === 'OK') {
            console.log(result.result.length);
            this.setState({ dbVersion: result.result.toLowerCase() });
          }
        },
        (error) => {
          this.setState({
            isLoaded: true,
            error
          });
        }
      )
  }

  getOperIds() {
    let aUrl = this.QRydeMappBaseUrl + '613GetOperIds?data=' + this.state.selectedDate + colSep + this.state.userName;
    let aDate = "";
    fetch(aUrl + aDate)
      .then(res => res.json())
      .then(
        (result) => {
          if (result != null && result.cmd_name != null && result.cmd_name === '613GetOperIds' && result.status != null
            && result.status === 'OK') {
            console.log(result.result.length);
            this.initOperidOptions(result.result);
          }
        },
        (error) => {
          this.setState({
            isLoaded: true,
            error
          });
        }
      )
  }


  validateLogin(theUserName, thePassword) {
    this.loginUserName = theUserName;
    this.socket = openSocket(this.GSENodeJsUrl);
    this.socket.on('finish',
      (data) => this.handleReceiveNodeJs(data)
    );
    this.socket.on('connect_error', function (data) {
      console.log(data.message)
    });
    this.socket.emit("ValidateLogin", this.state.userName, theUserName, thePassword);
    return;
    let aUrl = '/ValidateLogin?data=' + theUserName + colSep + thePassword;
    fetch(aUrl)
      .then(res => res.json())
      .then(
        (result) => {
          if (result != null && result.cmd_name != null && result.cmd_name === 'ValidateLogin' && result.status != null
            && result.status === 'OK' && result.result != null && result.result == "OK") {
            var aUser = {
              tenant_id: 1,
              user_id: theUserName,
              affiliation: "",
              first_name: " ",
              last_name: theUserName,
              email: "",
              phone: "",
              user_type: 0,
              lat: window.SiteConfig.defaultMapCenter[0],
              lng: window.SiteConfig.defaultMapCenter[1]
            };
            this.state.user = aUser;
            this.setState({ user: aUser });
            this.setSessionUser(aUser);
          } else {
            Modal.error({
              title: 'Unable to login',
              content: (
                <div>
                  <p>Please check User Name and Password then try again.</p>
                </div>
              )
            });
          }
        },
        (error) => {
          Modal.error({
            title: 'Unable to login',
            content: (
              <div>
                <p>Please check User Name and Password then try again.</p>
              </div>
            )
          });
        }
      )
  }


  initOperidOptions(theData) {
    if (theData != null && theData.length != 0) {
      let aTempOptions = [];
      for (var i = 0; i < theData.length; i++) {
        /* if (i == 0) {
          aTempOptions.push(<Option key={theData[i].oper_id} selected="selected">{theData[i].oper_name}</Option>);
        } else {
          aTempOptions.push(<Option key={theData[i].oper_id}>{theData[i].oper_name}</Option>);
        } */
        aTempOptions.push(<Option key={theData[i].oper_id}>{theData[i].oper_name}</Option>);
      }
      this.setState({ operidOptions: aTempOptions });
    }
  }

  getSchedulingOrders(isMonitoring) {
    if (isMonitoring && this.monitorSchedulingOrderTimeOut != null) {
      clearTimeout(this.monitorSchedulingOrderTimeOut);
    }
    // http:://192.168.38.105:4000/QRyde_Mapp/
    // http:://localhost:13004/
    // http:://50.233.95.50:4000/QRyde_Mapp/
    // let aUrl = 'http:://localhost:13004/613GetSchedulingOrder?data='+this.state.selectedDate+colSep+"penquis";
    // let aUrl = 'http:://localhost:13004/613GetSchedulingOrder?data=' + this.state.selectedDate + colSep + "atlantic";
    // let aUrl = 'http:://localhost:13004/613GetSchedulingOrder?data=' + "02-MAY-2018" + colSep + "penquis";
    // let aUrl = 'http:://localhost:13004/613GetSchedulingOrder?data=' + this.state.selectedDate + colSep + "FRNDRIDES";
    // let aUrl = 'http://50.233.95.50:4000/QRyde_Mapp/613GetSchedulingOrder?data=' + this.state.selectedDate + colSep + this.state.userName;
    let aUrl = this.QRydeMappBaseUrl + '613GetSchedulingOrder?data=' + this.state.selectedDate + colSep + this.state.userName + colSep + this.selectedOperid;
    fetch(aUrl)
      .then(res => res.json())
      .then(
        (result) => {
          if (result != null && result.cmd_name != null && result.cmd_name === '613GetSchedulingOrder' && result.status != null
            && result.status === 'OK') {
            if (result.result == null || result.result.length == 0) {
              if (this.state.reloadSchedulingOrdersCount < 3) {
                this.setState({ reloadSchedulingOrdersCount: this.state.reloadSchedulingOrdersCount + 1 });
                this.getSchedulingOrders();
                return;
              }
            }
            console.log(result.result.length);

            // result.result.push({});
            if (isMonitoring) {
              this.checkSchedulingOrder(result.result);
            } else {
              this.setState({ schedulingOrder: result.result });
              if (result.result.length < 2) {
                document.getElementById("myRightTopNav").style.width = "481px";
                this.setState({ activeSchedulingOrderCardIdx: 1 });
              }
            }
          }
        },
        (error) => {
          if (isMonitoring) {
            this.monitorSchedulingOrderTimeOut = setTimeout(function () { this.getSchedulingOrders(true); }.bind(this), this.state.monitorSchedulingOrderInterval);
          } else {
            if (this.state.reloadSchedulingOrdersCount < 3) {
              this.setState({ reloadSchedulingOrdersCount: this.state.reloadSchedulingOrdersCount + 1 });
              this.getSchedulingOrders();
            }
          }
        }
      )
  }

  getTrips() {
    this.showSpinModal(180, 50, "Initializing...");
    // let aUrl = 'http:://localhost:13004/613GetTripsNew?data=' + this.state.selectedDate + colSep + "penquis";
    // let aUrl = 'http:://localhost:13004/613GetTripsNew?data='+"10-MAY-2018"+colSep+"atlantic";
    // let aUrl = 'http:://localhost:13004/613GetTripsNew?data=' + this.state.selectedDate + colSep + "atlantic";
    // let aUrl = 'http:://localhost:13004/613GetTrips?data=' + this.state.selectedDate + colSep + "FRNDRIDES";
    // let aUrl = 'http://50.233.95.50:4000/QRyde_Mapp/613GetTrips?data=' + this.state.selectedDate + colSep + this.state.userName;
    let aUrl = this.QRydeMappBaseUrl + '613GetTrips?data=' + this.state.selectedDate + colSep + this.state.userName + colSep + this.selectedOperid;
    let aDate = "";
    fetch(aUrl + aDate)
      .then(res => res.json())
      .then(
        (result) => {
          this.hideSpinModal();
          if (result != null && result.cmd_name != null && result.cmd_name === '613GetTrips' && result.status != null
            && result.status === 'OK') {
            if (result.result == null || result.result.length == 0) {
              if (this.state.reloadTripsCount < 3) {
                this.setState({ reloadTripsCount: this.state.reloadTripsCount + 1 });
                this.getTrips();
                return;
              }
            }
            console.log(result.result.length);
            this.setState({ trips: this.correctLatLngs(result.result) });
            window.document.getElementById("left_btn_trips_sgements_right").hidden = true;
            document.getElementById("myLeftSidenav").hidden = false;
          }
        },
        (error) => {
          /* this.setState({
            isLoaded: true,
            error
          }); */
          this.hideSpinModal();
          if (this.state.reloadTripsCount < 3) {
            this.setState({ reloadTripsCount: this.state.reloadTripsCount + 1 });
            this.getTrips();
          }
        }
      )
  }

  getSchedules(theFindBestIdx) {
    // let aUrl = 'http:://localhost:13004/613GetSchedules?data=' + this.state.selectedDate + colSep + "penquis";
    // let aUrl = 'http:://localhost:13004/613GetSchedules?data='+"10-MAY-2018"+colSep+"atlantic";
    // let aUrl = 'http:://localhost:13004/613GetSchedules?data=' + this.state.selectedDate + colSep + "atlantic";
    // let aUrl = 'http:://localhost:13004/613GetSchedules?data=' + this.state.selectedDate + colSep + "FRNDRIDES";
    // let aUrl = 'http://50.233.95.50:4000/QRyde_Mapp/613GetSchedules?data=' + this.state.selectedDate + colSep + this.state.userName;
    let aUrl = this.QRydeMappBaseUrl + '613GetSchedules?data=' + this.state.selectedDate + colSep + this.state.userName + colSep + this.selectedOperid;
    let aDate = "";
    fetch(aUrl + aDate)
      .then(res => res.json())
      .then(
        (result) => {
          if (result != null && result.cmd_name != null && result.cmd_name === '613GetSchedules' && result.status != null
            && result.status === 'OK') {
            if (result.result == null || result.result.length == 0) {
              if (this.state.reloadSchedulesCount < 3) {
                this.setState({ reloadSchedulesCount: this.state.reloadSchedulesCount + 1 });
                this.getSchedules(theFindBestIdx);
                return;
              }
            }
            console.log(result.result.length);
            this.setState({ schedules: result.result });
            this.getSchedulesBrief(theFindBestIdx);
          }
        },
        (error) => {
          this.setState({
            isLoaded: true,
            error
          });
        }
      )
  }

  getSchedulesBrief(theFindBestIdx) {
    let aBrief = [];
    let aTempResNum = "";
    let aStartTime = "", aEndTime = "", aDriver = "", aVehicle = "";
    for (var i = 0; i < this.state.schedules.length; i++) {
      if (aTempResNum == null || aTempResNum.length == 0) {
        aTempResNum = this.state.schedules[i].res_num;
        aStartTime = this.state.schedules[i].triptime;
        aDriver = this.state.schedules[i].driver;
        aVehicle = this.state.schedules[i].vehicle;
      } else if (this.state.schedules[i].res_num != aTempResNum) {
        aEndTime = this.state.schedules[i - 1].triptime;
        aBrief.push({
          res_num: aTempResNum,
          start_time: aStartTime,
          end_time: aEndTime,
          driver: aDriver,
          vehicle: aVehicle
        })
        aTempResNum = this.state.schedules[i].res_num;
        aStartTime = this.state.schedules[i].triptime;
      }
    }
    this.setState({ schedulesBrief: aBrief });
    window.document.getElementById("left_btn_trips_sgements_right").hidden = true;
    document.getElementById("myLeftSidenav").hidden = false;
    if (theFindBestIdx >= 0) {
      // re-FindBest
      this.reFindBest(theFindBestIdx);
    }
  }

  correctLatLngs(theRes) {
    for (var i = 0; i < theRes.length; i++) {
      if (theRes[i].pu_lat * theRes[i].pu_lng === 0 && theRes[i].do_lat * theRes[i].do_lng != 0) {
        theRes[i].pu_lat = theRes[i].do_lat;
        theRes[i].pu_lng = theRes[i].do_lng;
      } else if (theRes[i].do_lat * theRes[i].do_lng === 0 && theRes[i].pu_lat * theRes[i].pu_lng != 0) {
        theRes[i].do_lat = theRes[i].pu_lat;
        theRes[i].do_lng = theRes[i].pu_lng;
      }
    }
    // return theRes;
    return this.correctTimeSlots(theRes);
  }

  correctTimeSlots(theRes) {
    for (var i = 0; i < theRes.length; i++) {
      if (theRes[i].time_slot === null || typeof theRes[i].time_slot !== 'number' || theRes[i].time_slot <= 0) {
        if (typeof theRes[i].est_pu_time === "number" && theRes[i].est_pu_time > 0) {
          theRes[i].time_slot = Math.ceil(theRes[i].est_pu_time / 15);
        }
      }
    }
    return theRes;
  }

  isEmptyObj(obj) {
    for (var prop in obj) {
      if (obj.hasOwnProperty(prop))
        return false;
    }
    return JSON.stringify(obj) === JSON.stringify({});
  }

  onDateShow() {
    console.log("onDateShow");
    if (!this.state.tripsPolylineFinishLoading) {
      Modal.warning({
        // title: 'Finalizing initialization.',
        title: 'Initializing ' + this.state.trips.length + ' trips.',
        content: 'Please wait...',
        onOk: this.handleModalOkClick.bind(this)
      });
    }
  }

  onDateChange(date) {
    /* this.setState({
      selectedDate: this.formatDate(date)
    }); */
    let aTempSelectedDate = this.state.selectedDate;
    if (!this.isSelectedDateValid(date)) {
      return;
    }
    this.endMonitorSchedulingOrder();
    this.map.current.resetMap();
    this.leftsidenav.current.tripstab.current.rtdtripstable.current.setState({ selectedRowKeys: [] });
    this.setState({
      trips: [],
      schedulingOrder: [],
      schedules: [],
      schedulesBrief: [],
      operidOptions: [<Option key="ALL">ALL OPERATORS</Option>],
      selectedOperid: "ALL",
      // monitorSchedulingSorder: "all",
      // monitorSchedulingOrderTimeOut: null,
      reloadSchedulingOrdersCount: 0,
      reloadTripsCount: 0,
      reloadSchedulesCount: 0,
      selectedDate: this.formatDate(date),
      activeSchedulingOrderCardIdx: 0,
      activeTripsSegmentsTabKey: "0",
      activeTab: 0,
      tripsPolylineFinishLoading: true
      // segmentsTabDisabled: true
    });
    this.selectedOperid = "ALL";
    this.selectedOperidIdx = 0;
    document.getElementsByClassName("operid_select")[0].value = "ALL OPERATORS";
    this.monitorSchedulingSorder = "all";
    this.monitorSchedulingOrderTimeOut = null;
    this.state.selectedDate = this.formatDate(date);
    document.getElementById("myRightBottomNav").hidden = true;
    window.document.getElementById("right_bottom_btn_manifest_left").hidden = true;
    document.getElementById("myRightTopNav").hidden = true;
    window.document.getElementById("right_top_btn_schedule_left").hidden = false;
    this.getOperIds();
    this.getSchedulingOrders(false);
    this.getTrips();
    this.getSchedules(-1);
    if (this.isPastDate(date)) {
      window.document.getElementById("right_top_btn_schedule_left").disabled = true;
    } else {
      window.document.getElementById("right_top_btn_schedule_left").disabled = false;
    }
  }

  isPastDate(theSelectedDate) {
    let aCurrentDate = new Date();
    aCurrentDate = new Date((aCurrentDate.getMonth() + 1) + '/' + aCurrentDate.getDate() + '/' + aCurrentDate.getFullYear());
    let aDiff = theSelectedDate - aCurrentDate;
    return aDiff < 0;
  }

  isSelectedDateValid(theSelectedDate) {
    return true;
    let aCurrentDate = new Date();
    aCurrentDate = new Date((aCurrentDate.getMonth() + 1) + '/' + aCurrentDate.getDate() + '/' + aCurrentDate.getFullYear());
    let aDiff = theSelectedDate - aCurrentDate;
    if (aDiff < 0 || aDiff >= 24 * 60 * 60 * 1000 * (window.SitConfig.DatePickerLimitation - 1)) {
      let aMaxDate = aCurrentDate.addDays(window.SitConfig.DatePickerLimitation);
      thisContext = this;
      Modal.error({
        title: 'Please select a date between ' + (aCurrentDate.getMonth() + 1) + '/' + aCurrentDate.getDate() + '/' + aCurrentDate.getFullYear() + ' and ' + (aMaxDate.getMonth() + 1) + '/' + aMaxDate.getDate() + '/' + aMaxDate.getFullYear(),
        onOk() {
          window.document.getElementsByClassName("date_picker_input")[0].children[0].children[0].value = (new Date(thisContext.state.selectedDate).getMonth() + 1) + '/' + new Date(thisContext.state.selectedDate).getDate() + '/' + new Date(thisContext.state.selectedDate).getFullYear();
        }
      });
      return false;
    } else {
      return true;
    }
  }

  formatDate(theDate) {
    let monthNames = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];

    let day = theDate.getDate();
    let monthIndex = theDate.getMonth();
    let year = theDate.getFullYear();

    if (day < 10) {
      return '0' + day + '-' + monthNames[monthIndex] + '-' + year;
    } else {
      return day + '-' + monthNames[monthIndex] + '-' + year;
    }
  }

  convertMinutesToAmPm(theMins) {
    let aIsAm = true;
    if (theMins >= 12 * 60) {
      aIsAm = false;
    }
    let aHr = 0, aMin = 0;
    let aHrStr = "", aMinStr = "";
    if (aIsAm) {
      if (aIsAm === 0) {
        return "0000A";
      }
      aHr = Math.floor(theMins / 60);
      aMin = theMins % 60;
      if (aHr < 10) {
        aHrStr = "0" + aHr.toString();
      } else {
        aHrStr = aHr.toString();
      }
      if (aMin < 10) {
        aMinStr = "0" + aMin.toString();
      } else {
        aMinStr = aMin.toString();
      }
      return aHrStr + aMinStr + "A";
    } else {
      if (theMins === 12 * 60) {
        return "1200P";
      }
      aHr = Math.floor((theMins - 12 * 60) / 60);
      aMin = (theMins - 12 * 60) % 60;
      if (aHr < 10) {
        if (aHr === 0) {
          aHrStr = "12";
        } else {
          aHrStr = "0" + aHr.toString();
        }
      } else {
        aHrStr = aHr.toString();
      }
      if (aMin < 10) {
        aMinStr = "0" + aMin.toString();
      } else {
        aMinStr = aMin.toString();
      }
      return aHrStr + aMinStr + "P";
    }
  }

  updateSchedulesBrief = (theSchedulesBrief) => { this.handelUpdateSchedulesBrief(theSchedulesBrief) }
  // updateActiveTab = (theIdx) => { this.setState({ activeTab: theIdx, activeTripsSegmentsTabKey: theIdx.toString() }) }
  updateActiveTab = (theIdx) => { this.handelUpdateActiveTab(theIdx) }
  updateTripsClustersRb = (theSelected) => { this.setState({ selectedTripsClustersRb: theSelected }) }
  updatePuDoRb = (theSelected) => { this.setState({ selectedPuDoRb: theSelected }) }
  updateSelectedTimeSlots = (theTimeSlots) => { this.setState({ selectedTimeSlots: theTimeSlots }) }
  updateSelectAllTimeSlots = (theSelectAllTimeSlots) => { this.setState({ selectAllTimeSlots: theSelectAllTimeSlots }) }
  updateTimeSlotMin = (theTimeSlotMin) => { this.setState({ timeSlotMin: theTimeSlotMin }) }
  updateTimeSlotMax = (theTimeSlotMax) => { this.setState({ timeSlotMax: theTimeSlotMax }) }
  updateTripsSelection = (theTrips) => { this.setState({ trips: theTrips }) }
  // updateTripsSelection = (theTrips) => { this.handelUpdateTripsSelection(theTrips) }
  updateStopSelection = (theStopIdx) => { this.handelUpdateStopSelection(theStopIdx) }
  updateStopSelections = (theStops) => { this.handelUpdateStopSelections(theStops) }
  updateStopsReorder = (theSegmentId, theSTripId, theTTripId, theSStopType, theTStopType, theDate) => { this.handleUpdateStopsReorder(theSegmentId, theSTripId, theTTripId, theSStopType, theTStopType, theDate) };
  // onClickScheduleBtn = (theIdx) => {this.getSchedulingOrders()}
  handleRightTopBtnSchedule = () => { this.toggleRightTopSideNav() }
  handleBottomBtnAnalysis = () => { this.toggleBottomSideNav() }
  handleRightBottomBtnManifest = () => { this.toggleRightBottomSideNav() }
  handleLeftBtnTripsSegments = () => { this.toggleLeftSideNav() }
  // handleTripsPolylineLoadingCompleted = () => { this.activateTripsTab() }
  handleTripsPolylineLoadingCompleted = () => { this.setState({ tripsPolylineFinishLoading: true }) }
  handelSchedulingOrderIdxChange = (theIdx) => { this.setState({ activeSchedulingOrderCardIdx: theIdx }) }

  handleUpdateStopsReorder(theSegmentId, theSTripId, theTTripId, theSStopType, theTStopType, theDate) {
    console.log("calling 613ReorderStops with: " + theSegmentId + "~" + theSTripId + "~" + theTTripId + "~" + theSStopType + "~" + theTStopType + "~" + theDate);
    let aUrl = this.QRydeMappBaseUrl + '613ReorderStops?data=' + theDate + colSep + this.state.userName + colSep + theSegmentId + colSep + theSTripId + colSep + theTTripId + colSep + theSStopType + colSep + theTStopType + colSep + "N" + colSep + "DEV";
    let aDate = "";
    fetch(aUrl + aDate)
      .then(res => res.json())
      .then(
        (result) => {
          console.log(result);
          if (result != null && result.cmd_name != null && result.cmd_name === '613ReorderStops' && result.status != null
            && result.status === 'OK') {
            // this.reloadSegmentsOnFinishFindBest(theSegmentId);
            this.map.current.handleReorderStopsFinish(theSegmentId);
          }
        },
        (error) => {
          // this.reloadSegmentsOnFinishFindBest(theSegmentId);
          this.map.current.handleReorderStopsFinish(theSegmentId);
        }
      )
  }

  handelUpdateTripsSelection(theTrips) {
    this.setState({ trips: theTrips });
    for (var i = 0; i < theTrips.length; i++) {
      if (typeof theTrips[i].selected !== "undefined" && theTrips[i].selected && theTrips[i].segment_id !== null && theTrips[i].segment_id.length !== 0) {
        for (var j = 0; j < this.state.schedules.length; j++) {
          if (theTrips[i].segment_id === this.state.schedules[j].res_num) {

          }
        }
      }
    }
  }

  handelUpdateActiveTab(theIdx) {
    if (theIdx === "1" && !this.state.tripsPolylineFinishLoading) {
      Modal.warning({
        // title: 'Finalizing initialization.',
        title: 'Initializing ' + this.state.trips.length + ' trips.',
        content: 'Please wait...',
        onOk: this.handleModalOkClick.bind(this)
      });
    } //else {
    this.setState({ activeTab: theIdx, activeTripsSegmentsTabKey: theIdx.toString() })
    //}
  }

  handleModalOkClick() {
    this.setState({
      activeTripsSegmentsTabKey: "0",
      activeTab: 0
    });
    if (document.getElementsByClassName("react-datepicker") !== null && document.getElementsByClassName("react-datepicker").length !== 0 && (typeof document.getElementsByClassName("react-datepicker")[0]) !== "undefined") {
      document.getElementsByClassName("react-datepicker")[0].hidden = true;
    }
  }

  handelUpdateSchedulesBrief(theSchedulesBrief) {
    window.document.getElementById("right_bottom_btn_manifest_left").hidden = true;
    this.setState({ schedulesBrief: theSchedulesBrief });
  }

  handelUpdateStopSelection(theStopIdx) {
    if (theStopIdx < -1) {
      return;
    }
    this.map.current.state.map.setView([this.map.current.state.selectedSegment[theStopIdx].lat, this.map.current.state.selectedSegment[theStopIdx].lng], 17);
    for (var i = 0; i < this.map.current.state.selectedSegment.length; i++) {
      this.map.current.state.selectedSegment[i].marker.closePopup();
    }
    this.map.current.state.selectedSegment[theStopIdx].marker.openPopup();
  }

  handelUpdateStopSelections(theStops) {
    for (var i = 0; i < this.map.current.state.selectedSegment.length; i++) {
      this.map.current.state.selectedSegment[i].marker.closePopup();
    }
    var aMarkers = [];
    for (var i = 0; i < theStops.length; i++) {
      aMarkers.push(theStops[i].marker);
      theStops[i].marker.openPopup();
    }
    if (aMarkers != null && aMarkers.length != 0) {
      this.map.current.zoomToMarkers(aMarkers);
    }
  }

  toggleLeftSideNav() {
    if (document.getElementById("myLeftSidenav").hidden) {
      window.document.getElementById("left_btn_trips_sgements_right").hidden = true;
      document.getElementById("myLeftSidenav").hidden = false;
    } else {
      document.getElementById("myLeftSidenav").hidden = true;
      window.document.getElementById("left_btn_trips_sgements_right").hidden = false;
    }
  }

  toggleRightTopSideNav() {
    if (document.getElementById("myRightTopNav").hidden) {
      window.document.getElementById("right_top_btn_schedule_left").hidden = true;
      document.getElementById("myRightTopNav").hidden = false;
    } else {
      document.getElementById("myRightTopNav").hidden = true;
      window.document.getElementById("right_top_btn_schedule_left").hidden = false;
    }
  }

  toggleRightBottomSideNav() {
    if (document.getElementById("myRightBottomNav").hidden) {
      window.document.getElementById("right_bottom_btn_manifest_left").hidden = true;
      document.getElementById("myRightBottomNav").hidden = false;
    } else {
      document.getElementById("myRightBottomNav").hidden = true;
      window.document.getElementById("right_bottom_btn_manifest_left").hidden = false;
    }
  }

  toggleBottomSideNav() {
    if (document.getElementById("myBottomNav").hidden) {
      window.document.getElementById("bottom_btn_analysis_up").hidden = true;
      document.getElementById("myBottomNav").hidden = false;
    } else {
      document.getElementById("myBottomNav").hidden = true;
      window.document.getElementById("bottom_btn_analysis_up").hidden = false;
    }
  }

  endMonitorSchedulingOrder() {
    clearTimeout(this.monitorSchedulingOrderTimeOut);
    this.monitorSchedulingOrderTimeOut = null;
    this.monitorSchedulingSorder = "all";
    // this.disableSelectOperid = false;
    this.setState({ disableSelectOperid: false });
  }

  startMonitorSchedulingOrder(theSorder) {
    if (this.monitorSchedulingOrderTimeOut != null) {
      return;
    }
    if (theSorder != null && theSorder.length != 0) {
      // this.disableSelectOperid = true;
      let aTemp = this.state.schedulingOrder;
      if (theSorder === "all") {
        for (var i = 0; i < aTemp.length; i++) {
          aTemp[i].when_started = "";
          aTemp[i].when_ended = "";
        }
      } else if (theSorder.indexOf("-") >= 0) {
        for (var i = 0; i < aTemp.length; i++) {
          if (aTemp[i].sorder >= parseInt(theSorder.split("-")[0]) && aTemp[i].sorder <= parseInt(theSorder.split("-")[1])) {
            aTemp[i].when_started = "";
            aTemp[i].when_ended = "";
          }
        }
      }
      else {
        for (var i = 0; i < aTemp.length; i++) {
          if (theSorder === "" + aTemp[i].sorder) {
            aTemp[i].when_started = "";
            aTemp[i].when_ended = "";
            break;
          }
        }
      }
      this.setState({ disableSelectOperid: true, schedulingOrder: aTemp });
      this.monitorSchedulingSorder = theSorder;
    }
    this.getSchedulingOrders(true);
    // this.monitorSchedulingOrderTimeOut = setTimeout(function () { this.getSchedulingOrders(true); }.bind(this), this.state.monitorSchedulingOrderInterval);
  }

  disableOperidSelection() {
    // this.disableSelectOperid = true;
    this.setState({ disableSelectOperid: true });
  }

  enableSelectOperid() {
    // this.disableSelectOperid = false;
    this.setState({ disableSelectOperid: false });
  }

  checkSchedulingOrder(theResult) {
    let aIsDone = true;
    if (this.monitorSchedulingSorder === "all") {
      for (var i = 0; i < theResult.length; i++) {
        if (theResult[i].when_ended === null || theResult[i].when_ended.length === 0) {
          aIsDone = false;
          break;
        }
      }
    } else if (this.monitorSchedulingSorder.indexOf("-") >= 0) {
      for (var i = 0; i < theResult.length; i++) {
        try {
          if ((theResult[i].sorder != null && (theResult[i].sorder >= parseInt(this.monitorSchedulingSorder.split("-")[0]) && theResult[i].sorder <= parseInt(this.monitorSchedulingSorder.split("-")[1]))) && (theResult[i].when_ended === null || theResult[i].when_ended.length === 0)) {
            aIsDone = false;
            break;
          }
        } catch (e) {
          aIsDone = false;
          break;
        }
      }
    } else {
      for (var i = 0; i < theResult.length; i++) {
        if ((theResult[i].sorder != null && theResult[i].sorder.toString() === this.monitorSchedulingSorder) && (theResult[i].when_ended === null || theResult[i].when_ended.length === 0)) {
          aIsDone = false;
          break;
        }
      }
    }
    this.setState({ schedulingOrder: theResult });
    if (aIsDone) {
      clearTimeout(this.monitorSchedulingOrderTimeOut);
      this.monitorSchedulingOrderTimeOut = null;
      this.monitorSchedulingSorder = "all";
      // this.disableSelectOperid = false;
      this.setState({ disableSelectOperid: false });
    } else {
      // this.setState({ monitorSchedulingOrderTimeOut: setTimeout(function () { this.getSchedulingOrders(true); }.bind(this), this.state.monitorSchedulingOrderInterval) });
      this.monitorSchedulingOrderTimeOut = setTimeout(function () { this.getSchedulingOrders(true); }.bind(this), this.state.monitorSchedulingOrderInterval);
    }
    if (theResult.length < 2) {
      document.getElementById("myRightTopNav").style.width = "481px";
      this.setState({ activeSchedulingOrderCardIdx: 1 });
    }
  }

  checkSchedulingOrderStatus() {
    if (this.monitorSchedulingOrderStatusTimeOut != null) {
      clearTimeout(this.monitorSchedulingOrderStatusTimeOut);
    }
    let aSelectedDate = this.state.selectedDate.replace("-20", "-");
    let aSiteName = this.state.userName.toUpperCase();
    // let socket = openSocket(this.GSENodeJsUrl);
    /* this.socket.on('finish', 
      (data) => this.handleReceiveSchedulingOrderStatus(data)
    ); */
    this.socket.emit("-v", aSiteName, aSelectedDate.toUpperCase());
    // this.monitorSchedulingOrderStatusTimeOut = setTimeout(function () { this.checkSchedulingOrderStatus(); }.bind(this), this.state.monitorSchedulingOrderStatusInterval);
  }

  handleReceiveNodeJs = (theData) => {
    if (theData !== null && theData.length !== 0) {
      try {
        theData = theData.replaceAll(":]", ":[]");
        if (JSON.parse(theData).Version != null && typeof JSON.parse(theData).Version != "undefined" && JSON.parse(theData).Version.length != 0) {
          console.log(theData);
          // this.setState({ nodeJSVersion: JSON.parse(theData) });
          this.setState({ gseVersion: JSON.parse(theData).Version.toLowerCase() });
        } else if (JSON.parse(theData).cmd != null && typeof JSON.parse(theData).cmd != "undefined" && JSON.parse(theData).cmd == 'ValidateLogin' &&
          JSON.parse(theData).status != null && typeof JSON.parse(theData).status != undefined && JSON.parse(theData).status == 'OK' &&
          JSON.parse(theData).result != null && typeof JSON.parse(theData).result != undefined && JSON.parse(theData).result.length != 0) {
          this.handleLoginResult(JSON.parse(theData).result);
        } else {
          this.handleReceiveSchedulingOrderStatus(theData)
        }
      } catch (e) {
        this.monitorSchedulingOrderStatusTimeOut = setTimeout(function () { this.checkSchedulingOrderStatus(); }.bind(this), this.state.monitorSchedulingOrderStatusInterval);
      }
    } else {
      this.handleReceiveSchedulingOrderStatus(theData)
    }
  }

  handleLoginResult(theResult) {
    if (true || theResult == 'OK') {
      this.setSessionUser({ user: this.loginUserName });
      this.setState({ sessionObj: { user: this.loginUserName } });
      this.getOperIds();
      this.getSchedulingOrders(false);
      this.getTrips();
      this.getSchedules(-1);
      this.setState({
        loginVisible: false,
      });
      this.checkSchedulingOrderStatus();
    } else {
      this.setSessionUser({});
    }
    this.loginUserName = "";
  }

  handleReceiveSchedulingOrderStatus = (theData) => {
    // this.setState({ schedulingOrderStatusData: JSON.parse(theData) });
    if (theData !== null && theData.length !== 0) {
      try {
        this.SchedulingOrderStatus.updateStatus(JSON.parse(theData));
        if (this.isEmptyObj(this.state.gseStatus) || theData !== JSON.stringify(this.state.gseStatus)) {
          this.setState({ gseStatus: JSON.parse(theData) });
          for (var i = 0; i < JSON.parse(theData).process.length; i++) {
            if (JSON.parse(theData).process[i].name.toUpperCase().indexOf("GSE_BATCH") >= 0) {
              if (JSON.parse(theData).process[i].status.toUpperCase() === "DONE") {
                if (this.monitorSchedulingOrderTimeOut != null) {
                  this.startMonitorSchedulingOrder("");
                }
                // this.endMonitorSchedulingOrder();
              } else {
                this.disableOperidSelection();
                var aBatchNotepadElements = JSON.parse(theData).process[i].notepad.split("^");
                var aSorderToMonitor = "all";
                if (aBatchNotepadElements != null && aBatchNotepadElements.length > 1) {
                  try {
                    var aBatchNotepadSorder = parseInt(aBatchNotepadElements[1]);
                    if (isNaN(aBatchNotepadSorder)) {
                      aSorderToMonitor = "all";
                    } else {
                      aSorderToMonitor = aBatchNotepadElements[1];
                    }
                  } catch (e) {
                    aSorderToMonitor = "all";
                  }
                } else {
                  aSorderToMonitor = "all";
                }
                // this.righttopsidenav.current.schedulingorderslidecards.current.setState({ runningSorder: aSorderToMonitor, isRunning: true });
                this.righttopsidenav.current.schedulingorderslidecards.current.setState({ isRunning: true });
                document.getElementsByClassName("stop_all_btn")[0].style.display = "block";
                document.getElementsByClassName("schedule_all_btn")[0].style.display = "none";
                document.getElementById("reset_all_btn").disabled = true;
                document.getElementById("finalize_btn").disabled = true;
                for (var i = 0; i < this.righttopsidenav.current.schedulingorderslidecards.current.state.data.length; i++) {
                  if (!this.isEmptyObj(this.righttopsidenav.current.schedulingorderslidecards.current.state.data[i])) {
                    document.getElementById("run_btn_" + this.righttopsidenav.current.schedulingorderslidecards.current.state.data[i].sorder).disabled = true;
                  }
                }
                document.getElementsByClassName("schedule_all_btn")[0].disabled = true;
                // this.startMonitorSchedulingOrder(aSorderToMonitor);
                this.startMonitorSchedulingOrder("");
              }
              break;
            }
          }
        }
      } catch (e) {
        this.SchedulingOrderStatus.updateStatus({});
        if (!this.isEmptyObj(this.state.gseStatus)) {
          this.setState({ gseStatus: {} });
        }
      }
      this.monitorSchedulingOrderStatusTimeOut = setTimeout(function () { this.checkSchedulingOrderStatus(); }.bind(this), this.state.monitorSchedulingOrderStatusInterval);
    } else {
      this.SchedulingOrderStatus.updateStatus({});
      if (!this.isEmptyObj(this.state.gseStatus)) {
        this.setState({ gseStatus: {} });
      }
      this.monitorSchedulingOrderStatusTimeOut = setTimeout(function () { this.checkSchedulingOrderStatus(); }.bind(this), this.state.monitorSchedulingOrderStatusInterval);
    }
  }

  emitUsernameEmpty = () => {
    this.userNameInput.focus();
    this.setState({ userName: '' });
  }
  onChangeUserName = (e) => {
    this.setState({ userName: e.target.value.toUpperCase() });
  }
  emitPasswordEmpty = () => {
    this.passowrdInput.focus();
    this.setState({ password: '' });
  }
  onChangePassword = (e) => {
    this.setState({ password: e.target.value });
  }

  testNodeSvr() {
    // aTestSocket.emit('ShowSchedules', '21-JUN-2018'+colSep+"FRNDRIDES");
    // aTestSocket.emit('GetSchedulingOrder', '21-JUN-2018'+colSep+"FRNDRIDES");
    aTestSocket.emit('GetTrips', '21-JUN-2018' + colSep + "FRNDRIDES");
  }

  onOperidSelectSelect(value, option) {
    console.log("onOperidSelectSelect");
    return false;
  }

  onSelectOperidChange(value, option) {
    console.log(`selected ${value}`);
    this.selectedOperid = value;
    for (var i = 0; i < this.state.operidOptions.length; i++) {
      if (this.state.operidOptions[i].key === value) {
        this.selectedOperidIdx = i;
        break;
      }
    }
    this.endMonitorSchedulingOrder();
    this.map.current.resetMap();
    this.leftsidenav.current.tripstab.current.rtdtripstable.current.setState({ selectedRowKeys: [] });
    this.setState({
      trips: [],
      schedulingOrder: [],
      schedules: [],
      schedulesBrief: [],
      selectedOperid: this.selectedOperid,
      // monitorSchedulingSorder: "all",
      // monitorSchedulingOrderTimeOut: null,
      reloadSchedulingOrdersCount: 0,
      reloadTripsCount: 0,
      reloadSchedulesCount: 0,
      activeSchedulingOrderCardIdx: 0,
      activeTripsSegmentsTabKey: "0",
      activeTab: 0,
      tripsPolylineFinishLoading: true
      // segmentsTabDisabled: true
    });
    this.monitorSchedulingSorder = "all";
    this.monitorSchedulingOrderTimeOut = null;
    document.getElementById("myRightBottomNav").hidden = true;
    window.document.getElementById("right_bottom_btn_manifest_left").hidden = true;
    document.getElementById("myRightTopNav").hidden = true;
    window.document.getElementById("right_top_btn_schedule_left").hidden = false;
    this.getSchedulingOrders(false);
    this.getTrips();
    this.getSchedules(-1);
  }


  onReceiveFindBestResult(theData, theIdx) {
    if (theData != null && theData.length != 0) {
      let aBrief = [];
      let aTempResNum = "";
      let aStartTime = "", aEndTime = "", aDriver = "", aVehicle = "";
      for (var i = 0; i < theData.length; i++) {
        innerloop: for (var j = 0; j < this.state.schedules.length; j++) {
          if (theData[i].Segment === this.state.schedules[j].res_num && (aTempResNum == null || aTempResNum.length == 0)) {
            aTempResNum = this.state.schedules[j].res_num;
            aStartTime = this.state.schedules[j].triptime;
            aDriver = this.state.schedules[j].driver;
            aVehicle = this.state.schedules[j].vehicle;
          } else if ((theData[i].Segment !== this.state.schedules[j].res_num && aTempResNum !== null && aTempResNum.length !== 0 && this.state.schedules[j].res_num != aTempResNum) || j == this.state.schedules.length - 1) {
            aEndTime = this.state.schedules[j - 1].triptime;
            let aIsExist = false;
            for (var x = 0; x < aBrief.length; x++) {
              if (aBrief[x].res_num === aTempResNum) {
                aIsExist = true;
                break;
              }
            }
            if (!aIsExist) {
              aBrief.push({
                res_num: aTempResNum,
                start_time: aStartTime,
                end_time: aEndTime,
                driver: aDriver,
                vehicle: aVehicle
              })
            }
            aTempResNum = "";
            aStartTime = "";
            break innerloop;
          }
        }
      }
      if (aBrief != null && aBrief.length != 0) {
        this.setState({
          schedulesBrief: aBrief,
          activeTripsSegmentsTabKey: "1",
          activeTab: 1
        });
      } else {
        let aThisContext = this;
        confirmModal({
          title: 'Didn\'t find matching results in current segments. Click Ok to refresh segments and try again.',
          onOk() {
            console.log("refresh segments and find best again");
            aThisContext.reloadSegmentsToFindBest(theIdx);
          }
        });
      }
      this.map.current.setFindBest(theData, theIdx);
      this.rightbottomsidenav.current.setFindBest(theData);
    }
  }

  clearFindBest() {
    this.rightbottomsidenav.current.clearFindBest();
  }

  reloadSegmentsOnFinishFindBest(theSegmentId) {
    this.setState({ schedules: [], schedulesBrief: [] });
    let aUrl = this.QRydeMappBaseUrl + '613GetSchedules?data=' + this.state.selectedDate + colSep + this.state.userName + colSep + this.selectedOperid;
    let aDate = "";
    fetch(aUrl + aDate)
      .then(res => res.json())
      .then(
        (result) => {
          if (result != null && result.cmd_name != null && result.cmd_name === '613GetSchedules' && result.status != null
            && result.status === 'OK') {
            if (result.result == null || result.result.length == 0) {
              if (this.state.reloadSchedulesCount < 3) {
                this.setState({ reloadSchedulesCount: this.state.reloadSchedulesCount + 1 });
                this.reloadSegmentsOnFinishFindBest(theSegmentId);
                return;
              }
            }
            console.log(result.result.length);
            this.setState({ schedules: result.result });
            this.getSchedulesBriefOnFinishFindBest(theSegmentId);
          }
        },
        (error) => {
          this.setState({
            isLoaded: true,
            error
          });
        }
      )
  }

  getSchedulesBriefOnFinishFindBest(theSegmentId) {
    let aBrief = [];
    let aTempResNum = "";
    let aStartTime = "", aEndTime = "", aDriver = "", aVehicle = "";
    for (var i = 0; i < this.state.schedules.length; i++) {
      if (aTempResNum == null || aTempResNum.length == 0) {
        aTempResNum = this.state.schedules[i].res_num;
        aStartTime = this.state.schedules[i].triptime;
        aDriver = this.state.schedules[i].driver;
        aVehicle = this.state.schedules[i].vehicle;
      } else if (this.state.schedules[i].res_num != aTempResNum) {
        aEndTime = this.state.schedules[i - 1].triptime;
        aBrief.push({
          res_num: aTempResNum,
          start_time: aStartTime,
          end_time: aEndTime,
          driver: aDriver,
          vehicle: aVehicle
        })
        if (aTempResNum === theSegmentId) {
          aBrief[aBrief.length - 1].selected = true;
        }
        aTempResNum = this.state.schedules[i].res_num;
        aStartTime = this.state.schedules[i].triptime;
      }
    }
    this.setState({ schedulesBrief: aBrief });
    // window.document.getElementById("left_btn_trips_sgements_right").hidden = true;
    // document.getElementById("myLeftSidenav").hidden = false;
  }

  handleRefreshTrips() {
    // this.map.current.clearTripsFromMap();
    // this.map.current.clearSelectedSetmentFromMap();
    this.map.current.resetMap();
    this.leftsidenav.current.tripstab.current.rtdtripstable.current.setState({ selectedRowKeys: [] });
    document.getElementById("myRightBottomNav").hidden = true;
    window.document.getElementById("right_bottom_btn_manifest_left").hidden = true;
    this.setState({
      trips: [],
      reloadTripsCount: 0,
      schedules: [],
      schedulesBrief: [],
      reloadSchedulesCount: 0
    });
    this.getTrips();
    this.getSchedules(-1);
  }

  reloadSegmentsToFindBest(theIdx) {
    this.map.current.mapHandleRefreshSegments();
    document.getElementById("myRightBottomNav").hidden = true;
    window.document.getElementById("right_bottom_btn_manifest_left").hidden = true;
    this.setState({
      schedules: [],
      schedulesBrief: [],
      reloadSchedulesCount: 0
    });
    this.getSchedules(theIdx);
  }

  reFindBest(theIdx) {
    let aSocket = openSocket(this.GSENodeJsUrl);
    let thisContext = this;
    aSocket.on('finish', function (data) {
      console.log('Caught Event "finish" after calling cmd, data: ' + data);
      // data = "<?xml version=\"1.0\" standalone=\"yes\"?><NewDataSet><Table><TripInfo>T11224152; Pickup ETA: 1251P; Dropoff ETA: 0117P; Impact: On time</TripInfo><Segid>S112</Segid><PuDist>0.000000</PuDist><DoDist>0.000000</DoDist><PUSTP>101</PUSTP><DOSTP>126</DOSTP><PuEtd>1252P</PuEtd><DoEtd>0117P</DoEtd><PUEDGE_START_ADDRESS>42.40915,-71.0377</PUEDGE_START_ADDRESS><PUEDGE_END_ADDRESS>42.410082,-71.0087</PUEDGE_END_ADDRESS><DOEDGE_START_ADDRESS>42.36961,-71.0353</DOEDGE_START_ADDRESS><DOEDGE_END_ADDRESS>42.362636,-71.0639</DOEDGE_END_ADDRESS><Trip_Pu>42.408617,-71.01179</Trip_Pu><Trip_Do>42.371635,-71.03562</Trip_Do><Segment>S112</Segment><PU_after>399</PU_after><DO_after>404</DO_after></Table><Table><TripInfo>T11224152; Pickup ETA: 1255P; Dropoff ETA: 0118P; Impact: On time</TripInfo><Segid>S112</Segid><PuDist>0.000000</PuDist><DoDist>0.000000</DoDist><PUSTP>106</PUSTP><DOSTP>126</DOSTP><PuEtd>1256P</PuEtd><DoEtd>0118P</DoEtd><PUEDGE_START_ADDRESS>42.410082,-71.0087</PUEDGE_START_ADDRESS><PUEDGE_END_ADDRESS>42.400967,-71.02849</PUEDGE_END_ADDRESS><DOEDGE_START_ADDRESS>42.36961,-71.0353</DOEDGE_START_ADDRESS><DOEDGE_END_ADDRESS>42.362636,-71.0639</DOEDGE_END_ADDRESS><Trip_Pu>42.408617,-71.01179</Trip_Pu><Trip_Do>42.371635,-71.03562</Trip_Do><Segment>S112</Segment><PU_after>400</PU_after><DO_after>404</DO_after></Table></NewDataSet>";
      if (data != null && data.length != 0 && data.toLowerCase().indexOf("no routes") < 0) {
        var aXmlData = parser.parseFromString(data, "text/xml");
        var aJsonData = thisContext.xmlToJson(aXmlData);
        if (!thisContext.isEmptyObj(aJsonData) && typeof aJsonData != "undefined" &&
          !thisContext.isEmptyObj(aJsonData.NewDataSet) && typeof aJsonData.NewDataSet != "undefined" &&
          typeof aJsonData.NewDataSet.Table != "undefined" && aJsonData.NewDataSet.Table != null && aJsonData.NewDataSet.Table.length != 0) {
          thisContext.onReceiveFindBestResult(aJsonData.NewDataSet.Table, theIdx);
        }
      } else {
        Modal.warning({
          content: "No route found."
        });
      }
    });
    console.log("Calling -f Cmd with: " + this.state.userName + "~" + (this.state.selectedDate.replace("-20", "-")).toUpperCase() + "~" + this.state.trips[theIdx].trip_id + "~" + this.state.trips[theIdx].pu_id + "~" + this.state.trips[theIdx].do_id)
    aSocket.emit("-f", this.state.userName, (this.state.selectedDate.replace("-20", "-")).toUpperCase(), this.state.trips[theIdx].trip_id, this.state.trips[theIdx].pu_id, this.state.trips[theIdx].do_id);
  }

  tempShowAllSegments(theBtnId) {
    let aTempSchedulesBrief = this.state.schedulesBrief;
    for (var i = 0; i < aTempSchedulesBrief.length; i++) {
      aTempSchedulesBrief[i].selected = false;
    }
    this.setState({ schedulesBrief: aTempSchedulesBrief });
    this.map.current.tempShowAllSegments(theBtnId, aTempSchedulesBrief, this.state.schedules);
    document.getElementById("myRightBottomNav").hidden = true;
  }

  openScheduleAllDialog() {
    this.scheduleAllDialog.current.openScheduleAllDialog();
  }

  handleBatchRange(theStartSorder, theEndSorder) {
    this.righttopsidenav.current.schedulingorderslidecards.current.handleBtnClkRange(theStartSorder, theEndSorder);
  }

  openLoginModal(e) {
    // this.validateLogin();
    this.loginModal.current.showLoginModal();
  }

  logOut() {
    var aThisContext = this;
    confirmModal({
      title: 'Confirm Logout?',
      onOk() {
        aThisContext.processLogout();
      }
    });
  }

  processLogout() {
    this.setSessionUser({});
    this.setState({ sessionObj: {} });
    document.getElementById("myLeftSidenav").hidden = true;
    document.getElementById("myBottomNav").hidden = true;
    document.getElementById("myRightTopNav").hidden = true;
  }

  showSpinModal(theWidth, theHeight, theTip) {
    this.setState({
      showSpinModal: true,
      spinModalWidth: theWidth,
      spinModalHeight: theHeight,
      spinTip: theTip
    });
  }

  hideSpinModal() {
    this.setState({
      showSpinModal: false,
      spinTip: ""
    });
  }

  render() {
    // this.initTrips();
    const styles = {
      container: {
        flex: 1,
        backgroundColor: 'white',
        alignItems: 'center',
        justifyContent: 'center'
      }
    }
    const { userName } = this.state;
    const { password } = this.state;
    const usernameSuffix = userName ? <AntIcn type="close-circle" onClick={this.emitUsernameEmpty} /> : null;
    const passwordSuffix = password ? <AntIcn type="close-circle" onClick={this.emitPasswordEmpty} /> : null;
    const ModalInfo = Modal.info;
    return (
      <div className="App" id="app">
        <Modal width={this.state.spinModalWidth} height={this.state.spinModalHeight}
          /*closable={true}*/
          closeIcon={<AntIcn type="minus" />}
          visible={this.state.showSpinModal}
          okButtonProps={{ hidden: true }}
          cancelButtonProps={{ hidden: true }}
          onCancel={this.cancelSpinModal}
        >
          <Spin tip={this.state.spinTip} />
        </Modal>
        <Modal
          title="Login"
          visible={this.state.loginVisible}
          okText="Login"
          onOk={this.handleLoginClick}
          closable={false}
          footer={[
            <AntdBtn key="login" type="primary" onClick={this.handleLoginClick}>
              Login
            </AntdBtn>,
          ]}
        >
          <p>User Name</p>
          <p><Input
            placeholder="Enter your username"
            prefix={<AntIcn type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}
            suffix={usernameSuffix}
            value={userName}
            onChange={this.onChangeUserName}
            ref={node => this.userNameInput = node}
          /></p>
          <p>Password</p>
          <p><Input type="password"
            placeholder="Enter your password"
            prefix={<AntIcn type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
            suffix={passwordSuffix}
            value={password}
            onChange={this.onChangePassword}
            ref={node => this.passowrdInput = node}
          /></p>

        </Modal>
        <LoginModal ref={this.loginModal} validateLogin={this.validateLogin.bind(this)} />
        <ScheduleAllDialog ref={this.scheduleAllDialog} userName={this.state.userName} data={this.state.schedulingOrder}
          selectedDate={this.state.selectedDate} selectedOperid={this.state.selectedOperid} handleBatchRange={this.handleBatchRange.bind(this)} />
        {/* <Layout>
          <Header style={{ position: 'fixed', width: '100%', backgroundColor: "lightblue" }}>
            <div id="header" style={{ width: 200, backgroundColor: "lightblue"}} >
              
              <Image style={{ width: 148.8, height: 66, border: 0 }}
                src={require("./img/QGSE.png")} />;
          </div>
            <div id="titlelabelright" >
              <DatePickerInput onChange={this.onDateChange} value={this.state.selectedDate} showOnInputClick />
            </div>
          </Header> */}

        <div style={{ width: "100%", height: 60, backgroundColor: "#2ACD3F", top: 0, position: "absolute", zIndex: 99 }}>
          <div id="header" >
            {/*<h1 id="title" >QRyde Global Scheduling Engine</h1>*/}
            <Image style={{ width: 135.29, height: 60, border: 0/*, borderRadius: "50%" */ }}
              src={require("./img/QGSE_5.png")} />
          </div>
          <div style={{ marginLeft: 138, marginTop: 35, width: 166, textAlign: 'left' }}><font size='2' color='black'>{this.state.gseVersion + "." + this.state.uiVersion + "." + this.state.dbVersion}</font></div>
          <div id="operidselectdiv" hidden={(this.isEmptyObj(this.state.sessionObj) || typeof this.state.sessionObj.user == "undefined" || this.state.sessionObj.user.length == 0) ? true : false}>
            <Select
              className="operid_select" size='default' value={this.state.operidOptions[this.selectedOperidIdx].props.children} style={{ width: 166 }} onChange={this.onSelectOperidChange} onSelect={this.onOperidSelectSelect} disabled={this.state.disableSelectOperid}>
              {this.state.operidOptions}
            </Select>
          </div>
          <SchedulingOrderStatus hidden={(this.isEmptyObj(this.state.sessionObj) || typeof this.state.sessionObj.user == "undefined" || this.state.sessionObj.user.length == 0) ? true : false} /*data={this.state.schedulingOrderStatusData}*/ onRef={ref => (this.SchedulingOrderStatus = ref)} />
          <div id="titlelabelright" >
            <AntdBtn hidden={(this.isEmptyObj(this.state.sessionObj) || typeof this.state.sessionObj.user == "undefined" || this.state.sessionObj.user.length == 0) ? false : true} id="login_btn" type="primary" shape="round" onClick={(e) => this.openLoginModal(e)} ><AntIcn type="login" />Login</AntdBtn>
            <DatePickerInput style={{ display: (this.isEmptyObj(this.state.sessionObj) || typeof this.state.sessionObj.user == "undefined" || this.state.sessionObj.user.length == 0) ? 'none' : 'block' }}
              className="date_picker_input" /*onClick={this.onDateClick}*/ onShow={this.onDateShow.bind(this)} onChange={this.onDateChange} value={this.state.selectedDate} showOnInputClick disabled={this.state.datePickerDisabled} />
          </div>
          <AntdBtn hidden={(this.isEmptyObj(this.state.sessionObj) || typeof this.state.sessionObj.user == "undefined" || this.state.sessionObj.user.length == 0) ? true : false}
            type="primary" shape="round" icon="logout" style={{ position: 'absolute', top: '12px', right: '5px' }} title="Logout" onClick={(e) => this.logOut(e)} />
        </div>
        <LeftSideNav sessionObj={this.state.sessionObj}
          ref={this.leftsidenav} className="left_nav" trips={this.state.trips} schedulesBrief={this.state.schedulesBrief}
          tripsPolylineFinishLoading={this.state.tripsPolylineFinishLoading} updateSchedulesBrief={this.updateSchedulesBrief}
          updateActiveTab={this.updateActiveTab} /*segmentsTabDisabled={this.state.segmentsTabDisabled}*/
          updateTripsClustersRb={this.updateTripsClustersRb} updatePuDoRb={this.updatePuDoRb} activeTripsSegmentsTabKey={this.state.activeTripsSegmentsTabKey}
          updateSelectedTimeSlots={this.updateSelectedTimeSlots} updateSelectAllTimeSlots={this.updateSelectAllTimeSlots}
          updateTripsSelection={this.updateTripsSelection} handleLeftBtnTripsSegments={this.handleLeftBtnTripsSegments}
          userName={this.state.userName} selectedDate={this.state.selectedDate} GSENodeJsUrl={this.GSENodeJsUrl}
          onReceiveFindBestResult={this.onReceiveFindBestResult} handleRefreshTrips={this.handleRefreshTrips} tempShowAllSegments={this.tempShowAllSegments.bind(this)} />
        <RightTopSideNav ref={this.righttopsidenav} userName={this.state.userName} data={this.state.schedulingOrder} selectedDate={this.state.selectedDate}
          handleRightTopBtnSchedule={this.handleRightTopBtnSchedule} activeCardIdx={this.state.activeSchedulingOrderCardIdx}
          handelSchedulingOrderIdxChange={this.handelSchedulingOrderIdxChange.bind(this)} startMonitorSchedulingOrder={this.startMonitorSchedulingOrder.bind(this)} endMonitorSchedulingOrder={this.endMonitorSchedulingOrder.bind(this)} enableSelectOperid={this.enableSelectOperid.bind(this)}
          disableOperidSelection={this.disableOperidSelection.bind(this)} QRydeMappBaseUrl={this.QRydeMappBaseUrl} GSENodeJsUrl={this.GSENodeJsUrl}
          selectedOperid={this.state.selectedOperid} openScheduleAllDialog={this.openScheduleAllDialog.bind(this)} GseSplitBatch={this.GseSplitBatch} />
        <RightBottomSideNav ref={this.rightbottomsidenav} schedulesBrief={this.state.schedulesBrief} schedules={this.state.schedules} handleRightBottomBtnManifest={this.handleRightBottomBtnManifest} updateStopSelection={this.updateStopSelection} updateStopSelections={this.updateStopSelections}
          userName={this.state.userName} selectedDate={this.state.selectedDate} GSENodeJsUrl={this.GSENodeJsUrl} QRydeMappBaseUrl={this.QRydeMappBaseUrl}
          updateStopsReorder={this.updateStopsReorder} />
        <BottomSideNav data={this.state.schedulingOrder} activeSchedulingOrderCardIdx={this.state.activeSchedulingOrderCardIdx} updateTimeSlotMin={this.updateTimeSlotMin} updateTimeSlotMax={this.updateTimeSlotMax} handleBottomBtnAnalysis={this.handleBottomBtnAnalysis}
          gseStatus={this.state.gseStatus} />
        <AntdBtn hidden={(this.isEmptyObj(this.state.sessionObj) || typeof this.state.sessionObj.user == "undefined" || this.state.sessionObj.user.length == 0) ? true : false} id="right_top_btn_schedule_left" type="primary" onClick={(e) => this.handleRightTopBtnSchedule(e)/*(e) => this.testNodeSvr(e)*/} style={{ top: 70, right: 0.86, position: "fixed", zIndex: 1 }}><AntIcn type="left" />Schedule</AntdBtn>
        <AntdBtn hidden={true} id="right_bottom_btn_manifest_left" type="primary" onClick={(e) => this.handleRightBottomBtnManifest(e)} style={{ /*bottom: "30.6%"*/bottom: 358, right: 0.86, position: "fixed", zIndex: 1 }}><AntIcn type="left" />Manifest</AntdBtn>
        <AntdBtn hidden={(this.isEmptyObj(this.state.sessionObj) || typeof this.state.sessionObj.user == "undefined" || this.state.sessionObj.user.length == 0) ? true : false} disabled={false} id="bottom_btn_analysis_up" type="primary" onClick={(e) => this.handleBottomBtnAnalysis(e)} style={{ bottom: "0%", right: "50%", position: "fixed", zIndex: 1 }}>Analytics<AntIcn type="up" /></AntdBtn>
        <AntdBtn hidden={true} id="left_btn_trips_sgements_right" type="primary" onClick={(e) => this.handleLeftBtnTripsSegments(e)} style={{ bottom: 600/*63.9%*/, left: 0.86, position: "fixed", zIndex: 1 }}>Trips / Segments<AntIcn type="right" /></AntdBtn>
        <Map ref={this.map} trips={this.state.trips} schedulesBrief={this.state.schedulesBrief} schedules={this.state.schedules} handleTripsPolylineLoadingCompleted={this.handleTripsPolylineLoadingCompleted}
          activeTab={this.state.activeTab} selectedTripsClustersRb={this.state.selectedTripsClustersRb} selectedPuDoRb={this.state.selectedPuDoRb}
          /*selectedTimeSlots={this.state.selectedTimeSlots} selectAllTimeSlots={this.selectAllTimeSlots}*/ clearFindBest={this.clearFindBest}
          timeSlotMin={this.state.timeSlotMin} timeSlotMax={this.state.timeSlotMax} getSchedulesBrief={this.getSchedulesBrief} QRydeMappBaseUrl={this.QRydeMappBaseUrl}
          userName={this.state.userName} selectedDate={this.state.selectedDate} GSENodeJsUrl={this.GSENodeJsUrl} reloadSegmentsOnFinishFindBest={this.reloadSegmentsOnFinishFindBest}
          OsrmBaseUrl={this.OsrmBaseUrl} />
        {/*<SharedRydeMap />*/}
        {/* <input id="titlelabelright" />
         <TripTable trips={this.state.trips} /> 
        <div id="titlelabelright" >
          <DatePicker
            onChange={this.onChange}
            value={this.state.date}
          />
        </div>*/}
        {/*</Layout>*/}
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js